var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 15.1667C4.04665 15.1667 0.833313 11.9533 0.833313 8C0.833313 4.04667 4.04665 0.833332 7.99998 0.833332C11.9533 0.833332 15.1666 4.04667 15.1666 8C15.1666 11.9533 11.9533 15.1667 7.99998 15.1667ZM7.99998 1.83333C4.59998 1.83333 1.83331 4.6 1.83331 8C1.83331 11.4 4.59998 14.1667 7.99998 14.1667C11.4 14.1667 14.1666 11.4 14.1666 8C14.1666 4.6 11.4 1.83333 7.99998 1.83333Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.16667C7.72667 9.16667 7.5 8.94 7.5 8.66667V5.33333C7.5 5.06 7.72667 4.83333 8 4.83333C8.27333 4.83333 8.5 5.06 8.5 5.33333V8.66667C8.5 8.94 8.27333 9.16667 8 9.16667Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 11.3333C7.91331 11.3333 7.82665 11.3133 7.74665 11.28C7.66665 11.2467 7.59331 11.2 7.52665 11.14C7.46665 11.0733 7.41998 11.0067 7.38665 10.92C7.35331 10.84 7.33331 10.7533 7.33331 10.6667C7.33331 10.58 7.35331 10.4933 7.38665 10.4133C7.41998 10.3333 7.46665 10.26 7.52665 10.1933C7.59331 10.1333 7.66665 10.0867 7.74665 10.0533C7.90665 9.98667 8.09331 9.98667 8.25331 10.0533C8.33331 10.0867 8.40665 10.1333 8.47331 10.1933C8.53331 10.26 8.57998 10.3333 8.61331 10.4133C8.64665 10.4933 8.66665 10.58 8.66665 10.6667C8.66665 10.7533 8.64665 10.84 8.61331 10.92C8.57998 11.0067 8.53331 11.0733 8.47331 11.14C8.40665 11.2 8.33331 11.2467 8.25331 11.28C8.17331 11.3133 8.08665 11.3333 7.99998 11.3333Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/InfoCircle.957e6a79.svg";
export { ForwardRef as ReactComponent };